// (() => {
//   // SELECTORS
//   const OPEN_BTN_SEL = "[data-details-product-delivery-open]";
//   const WRAPPER_SEL = ".details-product-delivery-and-return-content-wrapper";
//   const SHEET_SEL = ".details-product-delivery-and-return-content";
//   const CLOSE_BTN_SEL =
//     ".details-product-delivery-and-return-content__header span";
//   const HEADER_NAME_SEL =
//     ".details-product-delivery-and-return-content__header-name";
//   const LIST_CONTAINER_SEL =
//     ".details-product-delivery-and-return-content-inner";
//   const ITEM_SEL = "[data-details-product-delivery-item]";
//   const ITEM_TEXT_SEL = "[data-details-product-delivery-text]";

//   const wrapper = document.querySelector(WRAPPER_SEL);
//   const sheet = document.querySelector(SHEET_SEL);
//   const listContainer = document.querySelector(LIST_CONTAINER_SEL); 
//   let headerNameEl = document.querySelector(HEADER_NAME_SEL);

//   if (!wrapper || !sheet || !listContainer || !headerNameEl) return;

//   const headerEl = headerNameEl.closest(
//     ".details-product-delivery-and-return-content__header"
//   );
//   const originalHeaderTitle = headerNameEl.textContent.trim();

//   // Placeholder to restore header name node exactly where it was
//   const headerPlaceholder = document.createComment("header-name-placeholder");

//   // Build back button (arrow + dynamic name)
//   const backBtn = document.createElement("button");
//   backBtn.type = "button";
//   backBtn.className = "dpdr-back-btn";
//   backBtn.setAttribute("aria-label", "Back");
//   backBtn.style.display = "none";
//   headerEl.insertBefore(backBtn, headerNameEl); // keep arrow before the title initially

//   function setBackButtonLabel(name) {
//     backBtn.innerHTML = `
//       <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none" aria-hidden="true" focusable="false">
//         <path d="M6 11L1 6L6 1" stroke="black" stroke-linecap="square"/>
//       </svg>
//     `;
//     const span = document.createElement("span");
//     span.textContent = name;
//     backBtn.appendChild(span);
//   }

//   // Scroll lock helpers
//   const lockPageScroll = () => document.body.classList.add("body--lock-scroll");
//   const unlockPageScroll = () =>
//     document.body.classList.remove("body--lock-scroll");

//   const openSheet = () => {
//     wrapper.classList.add("is-open");
//     lockPageScroll();
//     exitSubView(); // reset
//   };

//   const closeSheet = () => {
//     wrapper.classList.remove("is-open");
//     unlockPageScroll();
//     exitSubView();
//   };

//   // --- Sub-view handling ---
//   function removeHeaderNameFromDOM() {
//     if (headerNameEl && headerNameEl.parentNode) {
//       headerEl.replaceChild(headerPlaceholder, headerNameEl); // keep position
//     }
//   }

//   function restoreHeaderNameToDOM() {
//     if (headerPlaceholder.parentNode) {
//       headerEl.replaceChild(headerNameEl, headerPlaceholder);
//     } else if (!headerNameEl.parentNode) {
//       // Fallback: place after back button
//       headerEl.insertBefore(headerNameEl, backBtn.nextSibling);
//     }
//   }

//   function enterSubView(itemEl) {
//     const nameEl = itemEl.querySelector(
//       ".details-product-delivery-and-return-content-inner__name"
//     );
//     const textEl = itemEl.nextElementSibling?.matches(ITEM_TEXT_SEL)
//       ? itemEl.nextElementSibling
//       : null;
//     if (!nameEl || !textEl) return;

//     const itemName = nameEl.textContent.trim();

//     // Back button shows arrow + item name
//     setBackButtonLabel(itemName);
//     backBtn.style.display = "inline-flex";

//     // Remove header name element from DOM (as requested)
//     removeHeaderNameFromDOM();

//     // Show only this item's text
//     listContainer.classList.add("is-sub-view");
//     listContainer
//       .querySelectorAll(ITEM_TEXT_SEL)
//       .forEach((n) => n.classList.remove("is-active"));
//     textEl.classList.add("is-active");

//     // Scroll to top for readability
//     sheet.scrollTo({ top: 0, behavior: "instant" });
//   }

//   function exitSubView() {
//     // Restore header name node and text
//     if (headerNameEl) headerNameEl.textContent = originalHeaderTitle;
//     restoreHeaderNameToDOM();

//     // Hide back button
//     backBtn.style.display = "none";

//     // Return to list view
//     listContainer.classList.remove("is-sub-view");
//     listContainer
//       .querySelectorAll(ITEM_TEXT_SEL)
//       .forEach((n) => n.classList.remove("is-active"));
//   }

//   // --- Events ---
//   document
//     .querySelectorAll(OPEN_BTN_SEL)
//     .forEach((btn) => btn.addEventListener("click", openSheet));

//   const closeBtn = document.querySelector(CLOSE_BTN_SEL);
//   if (closeBtn) closeBtn.addEventListener("click", closeSheet);

//   // Click outside the sheet (overlay) to close
//   wrapper.addEventListener("click", (e) => {
//     if (e.target === wrapper) closeSheet();
//   });

//   // Esc to close
//   document.addEventListener("keydown", (e) => {
//     if (e.key === "Escape" && wrapper.classList.contains("is-open"))
//       closeSheet();
//   });

//   // Enter sub-view
//   listContainer.addEventListener("click", (e) => {
//     const item = e.target.closest(ITEM_SEL);
//     if (!item || !listContainer.contains(item)) return;
//     enterSubView(item);
//   });

//   // Back -> exit sub-view
//   backBtn.addEventListener("click", exitSubView);
// })();


(() => {
  // SELECTORS
  const OPEN_BTN_SEL = "[data-details-product-delivery-open]";
  const WRAPPER_SEL = ".details-product-delivery-and-return-content-wrapper";
  const SHEET_SEL = ".details-product-delivery-and-return-content";
  const CLOSE_BTN_SEL =
    ".details-product-delivery-and-return-content__header span";
  const HEADER_NAME_SEL =
    ".details-product-delivery-and-return-content__header-name";
  const LIST_CONTAINER_SEL =
    ".details-product-delivery-and-return-content-inner";
  const ITEM_SEL = "[data-details-product-delivery-item]";
  const ITEM_TEXT_SEL = "[data-details-product-delivery-text]";

  const wrapper = document.querySelector(WRAPPER_SEL);
  const sheet = document.querySelector(SHEET_SEL);
  const listContainer = document.querySelector(LIST_CONTAINER_SEL);
  let headerNameEl = document.querySelector(HEADER_NAME_SEL);

  if (!wrapper || !sheet || !listContainer || !headerNameEl) return;
 
  const headerEl = headerNameEl.closest(
    ".details-product-delivery-and-return-content__header"
  );
  const originalHeaderTitle = headerNameEl.textContent.trim();

  // Placeholder to restore header name node exactly where it was
  const headerPlaceholder = document.createComment("header-name-placeholder");

  // Build back button (arrow + dynamic name)
  const backBtn = document.createElement("button");
  backBtn.type = "button";
  backBtn.className = "dpdr-back-btn";
  backBtn.setAttribute("aria-label", "Back");
  backBtn.style.display = "none";
  headerEl.insertBefore(backBtn, headerNameEl); // keep arrow before the title initially

  function setBackButtonLabel(name) {
    backBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none" aria-hidden="true" focusable="false">
        <path d="M6 11L1 6L6 1" stroke="black" stroke-linecap="square"/>
      </svg>
    `;
    const span = document.createElement("span");
    span.textContent = name;
    backBtn.appendChild(span);
  }

  // Scroll lock helpers
  const lockPageScroll = () => document.body.classList.add("body--lock-scroll");
  const unlockPageScroll = () =>
    document.body.classList.remove("body--lock-scroll");

  const openSheet = () => {
    wrapper.classList.add("is-open");
    lockPageScroll();
    exitSubView(); // reset
  };

  const closeSheet = () => {
    wrapper.classList.remove("is-open");
    unlockPageScroll();
    exitSubView();
  };

  // --- Sub-view handling ---
  function removeHeaderNameFromDOM() {
    if (headerNameEl && headerNameEl.parentNode) {
      headerEl.replaceChild(headerPlaceholder, headerNameEl); // keep position
    }
  }

  function restoreHeaderNameToDOM() {
    if (headerPlaceholder.parentNode) {
      headerEl.replaceChild(headerNameEl, headerPlaceholder);
    } else if (!headerNameEl.parentNode) {
      // Fallback: place after back button
      headerEl.insertBefore(headerNameEl, backBtn.nextSibling);
    }
  }

  function enterSubView(itemEl) {
    const nameEl = itemEl.querySelector(
      ".details-product-delivery-and-return-content-inner__name"
    );
    const textEl = itemEl.nextElementSibling?.matches(ITEM_TEXT_SEL)
      ? itemEl.nextElementSibling
      : null;
    if (!nameEl || !textEl) return;

    const itemName = nameEl.textContent.trim();

    // Back button shows arrow + item name
    setBackButtonLabel(itemName);
    backBtn.style.display = "inline-flex";

    // Remove header name element from DOM (as requested)
    removeHeaderNameFromDOM();

    // Show only this item's text
    listContainer.classList.add("is-sub-view");
    listContainer
      .querySelectorAll(ITEM_TEXT_SEL)
      .forEach((n) => n.classList.remove("is-active"));
    textEl.classList.add("is-active");

    // Scroll to top for readability
    sheet.scrollTo({ top: 0, behavior: "instant" });
  }

  function exitSubView() {
    // Restore header name node and text
    if (headerNameEl) headerNameEl.textContent = originalHeaderTitle;
    restoreHeaderNameToDOM();

    // Hide back button
    backBtn.style.display = "none";

    // Return to list view
    listContainer.classList.remove("is-sub-view");
    listContainer
      .querySelectorAll(ITEM_TEXT_SEL)
      .forEach((n) => n.classList.remove("is-active"));
  }

  // --- Events ---
  document
    .querySelectorAll(OPEN_BTN_SEL)
    .forEach((btn) => btn.addEventListener("click", openSheet));

  const closeBtn = document.querySelector(CLOSE_BTN_SEL);
  if (closeBtn) closeBtn.addEventListener("click", closeSheet);

  // Click outside the sheet (overlay) to close
  wrapper.addEventListener("click", (e) => {
    if (e.target === wrapper) closeSheet();
  });

  // Esc to close
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && wrapper.classList.contains("is-open"))
      closeSheet();
  });

  // Enter sub-view
  listContainer.addEventListener("click", (e) => {
    const item = e.target.closest(ITEM_SEL);
    if (!item || !listContainer.contains(item)) return;
    enterSubView(item);
  });

  // Back -> exit sub-view
  backBtn.addEventListener("click", exitSubView);
})();

// Back button action
document.addEventListener("click", (e) => {
  if (!e.target.closest(".dpdr-back-btn")) return;
 
  document
    .querySelectorAll(".details-product-delivery-and-return-content-inner__item-text")
    .forEach((el) => el.classList.remove("is-active"));
 
  const container = document.querySelector(".details-product-delivery-and-return-content-inner");
  if (container) container.classList.remove("is-sub-view");
});
